import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PageHeader from '../components/PageHeader';




// This component, creates an instance of <Route />. Props are passed in via <PrivateRoute> from AppRouter.
// then destructured below starting on the line with literal "PrivateRoute". While destructing,
// we pull out isAuthenticated and component. {...rest} gets all other properties in props
// aside from the two: isAuthenticated and component. On the next line starting with <Route
// Note that all properties EXCEPT for isAuthenicated and component are passed to <Route />
// via {...rest}.
// Also note that we want to make sure all props passed to Route are passed to the 
// individual component. This is then followed with  a condition.
// If user is authenticated then render the component with the props for that route.
// If user is not auththenticated redirect them to login page.
export const PrivateRoute = ({
    isAuthenticated,          // prop passed in from mapStateToProps;; this is also used as component props below 
    component: Component,     // prop passed in from AppRouter.js
    ...rest                   // the rest of the props that can be passed in by AppRouter.js. Note, when
                              // when destructuring, ...rest contains all other properties we did not destructure.
}) => (                       // Return an instance of Route component
    <Route {...rest} component={ (props) => (    // component prop is added since not part of ...rest
            isAuthenticated ? (
              <div>  
                <PageHeader />
                <Component {...props} />        
              </div>
            ) : (
                <Redirect to="/" />
            )
        )
    }   />
);

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.token    // !! converts truthy or falsy value to boolean
    
    // Line below was used with google authentication
    // isAuthenticated: !!state.auth.uid    // !! converts truthy or falsy value to boolean
});

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js